document.addEventListener('DOMContentLoaded', function() {
    const blogGrid = document.querySelector('.blog-grid');
    const noResultsMessage = document.querySelector('.no-results-message');
    const searchInputs = document.querySelectorAll('.blog-hero__search-input'); // Múltiples inputs (desktop + mobile)
    const searchForms = document.querySelectorAll('.blog-hero__search-form');
    const ctnPagination = document.querySelector('.ctn_pagination');
    const stickyContainer = document.querySelector('.ctn_sticky');
    const isBlogPage = searchForms.length > 0 && searchForms[0].getAttribute('data-blog-page') === 'true';
    
    let currentFilter = 'all';
    let currentSearch = '';
    let allArticles = [];
    let isLoadingPage = false;
    let isSearching = false;
    let originalPaginationHTML = '';
    let originalGridHTML = '';
    let searchDebounceTimer = null;

    // Load articles from DOM
    function loadArticlesFromDOM() {
        const cards = document.querySelectorAll('[data-filters-id][data-article-id]');
        allArticles = Array.from(cards).map((card) => {
            const titleEl = card.querySelector('.title');
            const categoryEl = card.querySelector('.category');
            return {
                element: card,
                tag: card.getAttribute('data-filters-id') || '',
                id: card.getAttribute('data-article-id') || '',
                title: (titleEl?.textContent || '').toLowerCase(),
                category: (categoryEl?.textContent || '').toLowerCase()
            };
        });
    }

    // Function to filter and display cards
    function filterAndDisplayCards(filterId, searchTerm = '') {
        const filtered = allArticles.filter((card) => {
            const matchesFilter = filterId === 'all' || card.tag === filterId;
            const matchesSearch = searchTerm === '' || 
                                card.title.includes(searchTerm) || 
                                card.category.includes(searchTerm);
            
            return matchesFilter && matchesSearch;
        });
        
        // Hide all cards first
        allArticles.forEach((card) => {
            card.element.style.display = 'none';
            card.element.setAttribute('aria-hidden', 'true');
        });
        
        // Show filtered cards
        filtered.forEach((card) => {
            card.element.style.display = 'block';
            card.element.setAttribute('aria-hidden', 'false');
        });
        
        // Show/hide no results message
        if (noResultsMessage) {
            if (filtered.length === 0) {
                const messageText = noResultsMessage.querySelector('.no-results-text');
                if (messageText) {
                    if (searchTerm !== '') {
                        messageText.textContent = `No articles found for "${searchTerm}". Try a different search term or category.`;
                    } else {
                        messageText.textContent = 'No articles found matching the selected filter. Please try a different category.';
                    }
                }
                noResultsMessage.style.display = 'block';
            } else {
                noResultsMessage.style.display = 'none';
            }
        }
    }

    // Function to apply filter and search
    function filterBlogCards(filterId, searchTerm = '') {
        currentFilter = filterId;
        currentSearch = searchTerm.toLowerCase();
        
        filterAndDisplayCards(filterId, currentSearch);
    }

    // Save original pagination and grid HTML
    function saveOriginalPagination() {
        console.log('Saving original pagination and grid HTML saveOriginalPagination');
        if (!originalPaginationHTML && ctnPagination) {
            const paginationElement = ctnPagination.querySelector('[data-pagination-ajax]');
            if (paginationElement) {
                originalPaginationHTML = paginationElement.outerHTML;
            }
        }
        
        if (!originalGridHTML && blogGrid) {
            originalGridHTML = blogGrid.innerHTML;
        }
    }
    
    // Function to perform search on blog cards
    function performBlogSearch(searchTerm) {
        // For blog pages, use Predictive Search API
        if (isBlogPage && searchTerm.trim() !== '') {
            if (stickyContainer) {
                stickyContainer.style.display = 'none';
            }
            performPredictiveSearch(searchTerm.trim());
        } else if (isBlogPage && searchTerm.trim() === '') {
            // Restore original pagination when search is cleared
            restoreOriginalPagination();
        } else {
            filterBlogCards(currentFilter, searchTerm);
        }
    }
    
    // Predictive Search API call
    async function performPredictiveSearch(query) {
        if (isSearching) return;
        
        isSearching = true;
        currentSearch = query;
        
        try {
            // Show loading state
            if (blogGrid) {
                blogGrid.style.opacity = '0.5';
            }
            
            // Call Predictive Search API
            const response = await fetch(`/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=article&resources[limit]=50&resources[options][fields]=title,body,tag`);
            
            if (!response.ok) throw new Error('Search request failed');
            
            const data = await response.json();
            const articles = data.resources.results.articles || [];
            
            // Display search results
            displaySearchResults(articles, query);
            
        } catch (error) {
            console.error('Predictive search error:', error);
            showSearchError();
        } finally {
            isSearching = false;
            if (blogGrid) {
                blogGrid.style.opacity = '1';
            }
        }
    }
    
    // Display search results
    function displaySearchResults(articles, query) {
        if (!blogGrid) return;
        
        // Hide pagination during search
        const paginationElement = ctnPagination.querySelector('[data-pagination-ajax]');
        if (paginationElement) {
            paginationElement.style.display = 'none';
        }
        
        // Clear current grid
        blogGrid.innerHTML = '';
        
        if (articles.length === 0) {
            // Show no results message
            if (noResultsMessage) {
                const messageText = noResultsMessage.querySelector('.no-results-text');
                if (messageText) {
                    messageText.textContent = `No articles found for "${query}". Try a different search term.`;
                }
                noResultsMessage.style.display = 'block';
            }
            return;
        }
        
        // Hide no results message
        if (noResultsMessage) {
            noResultsMessage.style.display = 'none';
        }
        
        // Get blog handle from grid data attribute
        const blogHandle = blogGrid.getAttribute('data-blog-handle');
        
        // Filter articles by blog handle if available
        const filteredArticles = blogHandle 
            ? articles.filter(article => article.url.includes(`/blogs/${blogHandle}/`))
            : articles;
        
        // Render articles
        filteredArticles.forEach(article => {
            const articleCard = createArticleCard(article);
            blogGrid.appendChild(articleCard);
        });
    }
    
    // Create article card HTML
    function createArticleCard(article) {
        const card = document.createElement('div');
        card.className = 'blog-card';
        card.setAttribute('data-filters-id', article.tags && article.tags.length > 0 ? article.tags[0] : '');
        card.setAttribute('data-article-id', article.id);
        
        const publishedDate = new Date(article.published_at);
        const formattedDate = publishedDate.toLocaleDateString('en-US', { 
            year: 'numeric', 
            month: 'short', 
            day: 'numeric' 
        });
        
        card.innerHTML = `
            <div>
                <div class="ctn_img">
                    <a href="${article.url}">
                        ${article.image ? `<img src="${article.image}" alt="${article.title}" loading="lazy" class="parallax-image">` : ''}
                    </a>
                </div>
                <div class="ctn_info">
                    <div class="ctn_date">
                        ${article.tags && article.tags.length > 0 ? `
                            <p class="category" data="${article.tags[0]}">
                                ${article.tags[0].substring(0, 33)}
                            </p>
                        ` : '<p class="category">No Category</p>'}
                        <span>|</span>
                        <p class="date">
                            <time datetime="${article.published_at}">${formattedDate}</time>
                        </p>
                    </div>
                    <a class="title" href="${article.url}">
                        ${article.title}
                    </a>
                </div>
            </div>
        `;
        
        return card;
    }
    
    // Restore original pagination
    function restoreOriginalPagination() {
        if (!ctnPagination || !blogGrid) return;
        if (stickyContainer) {
            stickyContainer.style.display = 'block';
        }
        
        isSearching = false;
        currentSearch = '';
        
        // Restore original grid HTML
        if (originalGridHTML) {
            blogGrid.innerHTML = originalGridHTML;
        }
        
        // Restore pagination
        const paginationElement = ctnPagination.querySelector('[data-pagination-ajax]');
        if (paginationElement && originalPaginationHTML) {
            paginationElement.outerHTML = originalPaginationHTML;
            // Re-initialize pagination event listeners
            initAjaxPagination();
        } else if (paginationElement) {
            paginationElement.style.display = '';
        }
        
        // Reload articles from restored DOM
        loadArticlesFromDOM();
        
        // Hide no results message
        if (noResultsMessage) {
            noResultsMessage.style.display = 'none';
        }
        
        // Apply current filter if any
        if (currentFilter !== 'all') {
            filterBlogCards(currentFilter, '');
        }
    }
    
    // Show search error
    function showSearchError() {
        if (noResultsMessage) {
            const messageText = noResultsMessage.querySelector('.no-results-text');
            if (messageText) {
                messageText.textContent = 'An error occurred while searching. Please try again.';
            }
            noResultsMessage.style.display = 'block';
        }
    }

    // Función para sincronizar valores entre todos los inputs de búsqueda
    function syncSearchInputs(sourceInput, value) {
        searchInputs.forEach(input => {
            if (input !== sourceInput) {
                input.value = value;
            }
        });
    }

    // Listen for search input events if search inputs exist
    if (searchInputs.length > 0) {
        // Agregar event listeners a todos los botones de búsqueda
        const searchButtons = document.querySelectorAll('.blog-hero__search-button');
        searchButtons.forEach(button => {
            button.addEventListener('click', function() {
                // Encontrar el input asociado a este botón
                const form = button.closest('.blog-hero__search-form');
                const input = form ? form.querySelector('.blog-hero__search-input') : searchInputs[0];
                if (input) {
                    const searchValue = input.value;
                    syncSearchInputs(input, searchValue);
                    performBlogSearch(searchValue);
                }
            });
        });

        // Agregar event listeners a todos los inputs de búsqueda
        searchInputs.forEach(searchInput => {
            searchInput.addEventListener('keypress', function(e) {
                if (e.key === 'Enter') {
                    e.preventDefault();
                    const searchValue = this.value;
                    syncSearchInputs(this, searchValue);
                    performBlogSearch(searchValue);
                }
            });

            searchInput.addEventListener('input', function() {
                const searchValue = this.value.trim();
                
                // Sincronizar con otros inputs
                syncSearchInputs(this, this.value);
                
                // Clear debounce timer
                if (searchDebounceTimer) {
                    clearTimeout(searchDebounceTimer);
                }
                
                if (searchValue === '') {
                    // Only restore if there was a previous search
                    if (isBlogPage && isSearching) {
                        restoreOriginalPagination();
                    } else if (isBlogPage && currentSearch !== '') {
                        restoreOriginalPagination();
                    } else if (!isBlogPage) {
                        filterBlogCards(currentFilter, '');
                    }
                } else if (isBlogPage) {
                    // Debounce search for blog pages
                    searchDebounceTimer = setTimeout(() => {
                        performBlogSearch(searchValue);
                    }, 500);
                } else {
                    filterBlogCards(currentFilter, searchValue);
                }
            });
        });
    }

    const blogNavigationSection = document.querySelector('.blog_navigation');
    if (blogNavigationSection) {
        document.addEventListener('filterChanged', function(event) {
            const filterId = event.detail.filterId;
            currentFilter = filterId;
            
            // If filter is 'all' on blog page, restore original HTML
            if (isBlogPage && filterId === 'all') {
                restoreOriginalPagination();
            } else {
                filterBlogCards(filterId, currentSearch);
            }
        });
    }

    // AJAX Pagination
    function initAjaxPagination() {
        const paginationContainer = document.querySelector('[data-pagination-ajax]');
        if (!paginationContainer) return;

        paginationContainer.addEventListener('click', function(e) {
            const link = e.target.closest('.pagination-ajax-link');
            if (!link || isLoadingPage) return;

            e.preventDefault();
            e.stopPropagation();

            const pageUrl = link.getAttribute('data-page');
            if (!pageUrl) return;

            loadPageAjax(pageUrl);
        });
    }

    async function loadPageAjax(url) {
        if (isLoadingPage) return;
        
        isLoadingPage = true;
        
        try {
            // Add loading state
            if (ctnPagination) {
                ctnPagination.style.opacity = '0.5';
                ctnPagination.style.pointerEvents = 'none';
            }

            const response = await fetch(url);
            if (!response.ok) throw new Error('Network response was not ok');
            
            const html = await response.text();
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');

            // Extract new blog grid
            const newBlogGrid = doc.querySelector('.blog-grid');
            const newPagination = doc.querySelector('[data-pagination-ajax]');

            if (newBlogGrid && blogGrid) {
                // Replace blog grid content
                blogGrid.innerHTML = newBlogGrid.innerHTML;
                
                // Reload articles from new DOM
                loadArticlesFromDOM();
                
                // Reapply current filter and search
                filterAndDisplayCards(currentFilter, currentSearch);
            }

            // Replace pagination
            const currentPagination = document.querySelector('[data-pagination-ajax]');
            if (newPagination && currentPagination) {
                currentPagination.outerHTML = newPagination.outerHTML;
                // Re-initialize pagination event listeners
                initAjaxPagination();
            }

            // Scroll to top of blog section smoothly
            const blogNavigation = document.querySelector('.blog_navigation');
            if (blogNavigation) {
                const offset = 100;
                const elementPosition = blogNavigation.getBoundingClientRect().top;
                const offsetPosition = elementPosition + window.pageYOffset - offset;

                window.scrollTo({
                    top: offsetPosition,
                    behavior: 'smooth'
                });
            }

            // Update URL without page reload
            if (window.history && window.history.pushState) {
                window.history.pushState({path: url}, '', url);
            }

        } catch (error) {
            console.error('Error loading page:', error);
            // Fallback to normal navigation
            window.location.href = url;
        } finally {
            isLoadingPage = false;
            
            // Remove loading state
            if (ctnPagination) {
                ctnPagination.style.opacity = '1';
                ctnPagination.style.pointerEvents = 'auto';
            }
        }
    }

    // Handle browser back/forward buttons
    window.addEventListener('popstate', function(event) {
        if (event.state && event.state.path) {
            loadPageAjax(event.state.path);
        } else {
            location.reload();
        }
    });
    
    document.addEventListener('paginationRestored', function() {
        // Reinitialize AJAX pagination after filter restoration
        initAjaxPagination();
        // Reload articles from restored DOM
        loadArticlesFromDOM();
    });

    // Initialize
    loadArticlesFromDOM();
    
    // Save original pagination on load
    if (isBlogPage) {
        saveOriginalPagination();
    }
    
    filterBlogCards('all');
    initAjaxPagination();
});